import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

/** Owner/Admin portfolio previews need authenticated bytes even on token-only native sessions. */
export function PortfolioMediaPreview({ mediaId, revision = "", alt, className }: {
  mediaId: string; revision?: string; alt: string; className: string;
}) {
  const { user } = useAuth();
  const scope = `${user?.id ?? "guest"}:${user?.activeContext ?? "personal"}:${mediaId}:${revision}`;
  const [preview, setPreview] = useState<{ scope: string; url: string | null; failed: boolean } | null>(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const abort = new AbortController();
    let url: string | null = null;
    setPreview(null);
    void api.portfolioMediaBlob(mediaId, abort.signal).then((blob) => {
      if (abort.signal.aborted) return;
      url = URL.createObjectURL(blob);
      setPreview({ scope, url, failed: false });
    }).catch(() => {
      if (!abort.signal.aborted) setPreview({ scope, url: null, failed: true });
    });
    return () => { abort.abort(); if (url) URL.revokeObjectURL(url); };
  }, [mediaId, scope, retry]);
  const current = preview?.scope === scope ? preview : null;
  if (current?.url) return <img src={current.url} alt={alt} className={className} />;
  return <div className={className}>{current?.failed
    ? <button type="button" className="text-xs underline" aria-label={`Retry ${alt}`} onClick={() => setRetry((attempt) => attempt + 1)}>Retry photo</button>
    : <span role="status" className="text-xs text-mut">Loading photo…</span>}</div>;
}
